export default {
  'to-ss': 'Mintegral出稿管理画面',
  domain: {
    tips: {
      title: 'ドメイン変更のお知らせ',
      content:
        'より安定したサービスを提供するため、アクセスアドレスを更新しました。現在のドメインはまもなく使用できなくなりますので、できるだけ早く新しいドメインに移行し、再度ログインして正常にアクセスできるようにしてください。',
      submit: '今すぐ移動',
    },
  },
  'to-helper': 'ヘルプセンター',
  confirmTitle: '現在のプロジェクトを削除しますか？',
  confirmTips: '現在のプロジェクトは削除され、復元することはできません。',
  confirmButtonText: '確認',
  cancelButtonText: 'キャンセル',
  enterPlaceHolder: '記入してください',
  agreement: '機密契約',
  createVersionDialog: {
    version: 'バージョン',
    title: '新しいバージョンを作成',
    createSuccessText: '作成成功',
    confirmText: '確認',
    cancleText: 'キャンセル',
    form: {
      name: {
        label: 'バージョン名',
        placeholder: 'バージョン名を入力してください',
        required: 'バージョン名は空白にできません',
        length: '50文字を超えてはいけません',
        format:
          'アンダースコアを含む英数字のみを入力できます（スペースは入力できません）',
        duplicateName: 'その名前は既に存在します',
      },
      description: {
        placeholder: 'バージョンの説明を入力してください',
        required: 'バージョンの説明は空白にできません',
        length: '500文字を超えてはいけません',
      },
    },
  },
  downloadTaskDialog: {
    title: '圧縮リスト',
    loading: '圧縮中',
    failed: '圧縮に失敗しました',
    running: {
      a: '圧縮中',
      b: '個のファイル',
    },
    download: 'ダウンロードをクリック',
    packed: '圧縮された',
    stopDialog: {
      message: '圧縮を中止しますか？',
      content:
        'ファイルの圧縮が完了していないため、ダウンロードできません。中止しますか？',
      keep: 'ダウンロードを続ける',
      cancel: 'ダウンロードをキャンセル',
    },
  },
  playUnitTitle: 'ショートカットの配置',
  fontForbidden: {
    msg: 'このプロジェクトには既に販売終了したフォントが含まれています。フォントを再選択してください',
    set: '設定に移動',
    cancel: 'キャンセル',
    ok: 'OK',
    msgDialog:
      '以下のフォントが見つかりませんでした。使用できないため、代わりのフォントを選択してください。',
  },
  downloadVersionDialog: {
    title: '作品のダウンロード',
    version: {
      new: '最新バージョン',
      history: 'ヒストリカルバージョン',
    },
    package: {
      status: {
        label: 'ステータス',
        ready: '未ダウンロード',
        done: 'ダウンロード済み',
      },
      zipType: {
        label: '圧縮方法',
        normal: 'スマート圧縮（ファイルの品質とサイズのバランス）',
        custom: 'カスタム圧縮',
      },
      downloadNotice: 'チャネルをチェックしてください',
      previewTitle: 'パッケージの圧縮プレビュー',
      back: 'ダウンロードに戻る',
      label: 'パッケージコントロール',
      image: '品質',
      qualityLabel: {
        normal: '品質の選択',
        image: '画像品質',
        video: '動画品質',
        audio: '音声品質',
      },
      counting: 'パッケージ計算中',
      apply: '適用して計算する',
      preview: 'プレビュー',
      desc: '実際のパッケージ',
      fileSize: 'パッケージサイズ',
      limit: '制限なし',
    },
    downloadTips:
      'このチャネルからダウンロードしたファイルは広告に使用できません。【プッシュ】機能を使用し、Mintergralの出稿よう管理画面に一括でアップロードすることをお勧めします。',
    deploymentTips:
      '素材を正常に動作させるためには、InMobiのプレイアブル素材をダウンロードした後、オフラインスクリプトの内容をCDNにデプロイし、HTML内のパスを手動で修正する必要があります。',
    eventDetectionTips:
      '終了シーンまたはイベントを設定してからやり直してください。',
    mtgDisabledTips:
      'ダウンロードは必要ありません。Mintegralの出稿用管理画面に一括でアップロードできます',
    notProduct: 'まず製品情報を選択してください。',
    unauthorized: 'チャネルは許可されていません',
    channelLable: {
      mintegral: '自分のチャネル',
      other: '外部のチャネル',
      choose: 'チャネルを選択',
    },
    table: {
      column: {
        channel: 'チャネル',
        platform: 'プラットフォーム',
      },
      action: {
        checkall: 'すべて選択',
      },
      disabledDownload: 'このチャンネルはダウンロードに対応していません',
    },
    download: 'ダウンロード',
    copylink: 'リンクを取得',
    wxgame: {
      disableTips:
        'プロジェクトにはWeChatでサポートされていない機能が含まれています。調整して再試行してください。',
      ctaTips:
        'WeChat MiniGameはアプリストアへのリダイレクトをサポートしていません。関連するCTAボタンやステップを削除してください。',
      previewTips:
        'WeChat MiniGameの試用版はプレビューをサポートしていません。プロジェクトプレビューを通じて試用版の効果を確認できます。',
    },
  },
  plPreview: {
    history: {
      tips: '過去のバージョンは、既にダウンロードされたチャネルでの再ダウンロードのみ対応しており、二次送信はサポートされていません。',
    },
    crumb: {
      ps: {
        title: 'プレイアブルコンテンツエディタ',
      },
    },
    creativeName: {
      placeHolder: 'クリエイティブの名前を入力してください。',
    },
  },
  pushDialog: {
    title: 'プッシュ',
    accountOptions: {
      local: '現在のアカウント',
      other: '別のアカウント',
      new: '新しいアカウントを追加',
    },
    cancleLabel: 'キャンセル',
    confirmLabel: '確認',
    form: {
      accountType: {
        label: 'プッシュアカウント',
        message: 'プッシュアカウントを選択してください',
        placeholder: 'プッシュアカウントを選択してください',
      },
      name: {
        label: 'アカウント',
        message: 'ユーザー名またはメールアドレスを入力してください',
        placeholder: 'ユーザー名またはメールアドレスを入力してください',
      },
      password: {
        label: 'パスワード',
        message: 'パスワードを入力してください',
        placeholder: 'パスワードを入力してください',
      },
    },
    packageManager: {
      remainLable: 'ダウンロード残り',
      totalLabel: '合計',
      remainTips: {
        A: '合計 = 30日のダウンロード数 + 追加のダウンロード数',
        B: '30日ごとにダウンロード数がリセットされます（追加のダウンロード数は除く）',
      },
      progress: {
        network: 'チャネル',
        version: '作品',
        download: 'ダウンロード数',
      },
      overTips:
        '選択した数量が残りのダウンロード数を上回っています。数量を減らしてください。',
      mintegral:
        'Mintegralプラットフォーム向けのダウンロードはダウンロード数にカウントされません',
    },
    pushSuccess: 'プッシュ成功',
    pushSuccessA: 'プッシュ成功',
  },
  pushInfoConfirm: {
    title: 'ヒント',
    cancel: 'キャンセル',
    info: '追加情報',
    emptyText:
      'この機能を使用するには製品情報が不足しています。製品情報を追加してください',
  },
  eventInfoConfirm: {
    title: '{title}できません',
    info: '設定に移動',
    setUp: '設定方法を確認',
    emptyInstallText:
      '現在のプロジェクトにはアプリストアへのリダイレクトイベントがありません。再設定後に{info}を実行してください。',
    emptyGameEndText:
      '現在のプロジェクトには終了シーンまたはイベントがありません。再設定後に{info}を実行してください。',
    emptyNullText:
      '現在のプロジェクトにはアプリストアへのリダイレクトイベント、終了シーおよびイベントがありません。再設定後に{info}を実行してください。',
  },
  pushRecordDialog: {
    title: 'Mintegralへのプッシュ履歴',
    emptyText: 'この素材はまだMintegralの出稿管理画面にプッシュされていません',
    closeLabel: '閉じる',
    goToAdPlatform: 'Mintegral出稿用管理画面',
    table: {
      title: '作品名',
      language: '言語',
      platform: 'プラットフォーム',
      advName: 'プッシュアカウント',
      status: 'ステータス',
      updateTime: 'プッシュ時間',
      action: '操作',
      preview: 'プレビュー',
      download: 'ダウンロード',
      info: 'プロジェクト情報',
    },
    statusList: {
      pending: '審査中',
      approved: 'プッシュ成功',
      rejected: '未承認',
      failed: 'プッシュ失敗',
      downloaded: 'ダウンロード済み',
      other: 'その他の理由',
    },
  },
  historyList: {
    table: {
      column: {
        count: '差し引き回数',
        countAll: '合計差し引き回数',
        templateName: 'テンプレート名',
        time: '最終更新時間',
        fingerprintCount: 'etc., 合計{num}',
        basicId: 'クリエイティブIDと名称',
        creative_version: 'クリエイティブバージョン名',
        basicIdCount: 'および他のクリエイティブバージョンID',
      },
    },
  },
  pushdownloadRecordDialog: {
    title: 'エクスポート＆ダウンロード履歴',
    emptyText: '現在のリストは空です',
    table: {
      count: '差し引き回数',
      channel: 'チャネル',
      updateTime: '作成時間',
      fingerprint: 'クリエイティブフィンガープリント',
      export: 'Excelをエクスポート',
    },
    search: {
      isDecuction: '回数を差し引くかどうか',
      decuction: '差し引く',
      notDecuction: '差し引かない',
      channel: 'ネットワークを選択',
      platform: 'プラットフォーム選択',
    },
    infoDialog: {
      lang: '言語',
      account: 'プッシュアカウント',
    },
  },
  versionBar: {
    exportButton: 'エクスポート',
    createGuide: '新しいバージョン',
    copyButton: 'バージョンをコピー',
    deleteButton: 'バージョンを削除',
    deleteSuccess: '削除完了',
    switchSuccess: '切替完了',
    deleteForbidden: '現在の編集バージョンは削除できません',
    saveWarningText: '素材は保存中です。他の操作はしないでください',
    deleteConfirm: {
      title: 'ヒント',
      content: 'このバージョンを削除してもよろしいですか？',
      header: '選択されたプロジェクト',
      confirmButtonText: '確認',
      cancelButtonText: 'キャンセル',
    },
    option: {
      copyButton: 'コピー',
      deleteButton: '削除',
      downloadButton: 'ダウンロード',
      copyToMulti: '複数の組み合わせにコピー',
      copyToPs: 'コンテンツエディタにコピー',
      copyToDco: 'DCOにコピー',
    },
    saveConfirm: {
      type: {
        copy: 'コピー',
        choose: 'バージョンの切り替え',
        create: '作成',
        export: 'エクスポート',
      },
      content: '現在のバージョンを保存しますか？',
      title: 'ヒント',
      confirmButtonText: 'はい',
      cancelButtonText: 'いいえ',
    },
  },
  langSelector: {
    label: 'デフォルトの言語',
  },
  errorpage: {
    message: 'リンクが正しくありません。もう一度入力してください',
    homeButton: 'ホームに戻る',
  },
  listNav: {
    menu: {
      normal: '通常の作成',
      dco: 'DCOの作成',
      multi: '複数の組み合わせの作成',
    },
    starButton: 'お気に入り',
  },
  previewDialog: {
    preview: 'プレビュー',
    copyText: 'リンクをコピーしてブラウザに貼り付けてください',
    copyButton: 'コピー',
    reloadButton: '再生',
    replay: '再生',
    product: '製品',
    playable: 'プロジェクト',
    versionName: 'バージョン名',
    dcoid: '組み合わせID',
    dcoIdDesc:
      '1つのDCO IDには複数の組み合わせがあり、各組み合わせはそれぞれ1つのグループIDに紐づきます',
    dcoConfiguration: 'DCO設定',
    createVersion: '新規プロジェクトを作成',
    createMultiVersion: '新しい複数の組み合わせバージョンを作成',
    createDCOVersion: '新規DCOバージョンの追加',
    editVersion: '編集バージョン',
    copyVersion: 'プロジェクトの複製',
    copyMultiVersion: '複数の複合プロジェクトをコピー',
    copyNewDCOVersion: 'DCOバージョンのコピー',
    versionManagement: 'バージョン管理',
  },
  save: {
    autoSaving: '自動保存中...',
    saved: 'すべての変更は保存されました',
    text: '保存',
    fail: '保存に失敗しました',
  },
  validate: {
    numberOnly: '数字のみの検索がサポートされています',
  },
  balanceThresholdTips:
    'アカウント残高が $ {balance_threshold} 未満になりました。サービスの中断を避けるため、早めにリチャージしてください。',
  network: {
    networkException:
      'ネットワークエラーが発生しました。リフレッシュしてください。',
  },
  poinitManagement: {
    desc: 'トラッキングポイントを追加すると、クリエイティブにはインタラクティブデータ分析、シーン分析、ユーザージャーニー分析などの高度な分析機能が利用可能です。',
    select: {
      tips: 'チェックすると、該当チャンネルに全てのダウンロード/プッシュされたプレーアブルクリエイティブにトラッキングコードが追加されます。（現時点では上記のチャネルのみサポートされています。他のチャネルをサポート希望の場合、担当者までお問い合わせください。）チェックしない場合は追加されません。トラッキングコードの追加をお勧めします。トラッキングコードを追加すると、クリエイティブにはインタラクティブデータ分析、シーン分析、ユーザージャーニー分析などの高度な分析機能を利用可能です。',
    },
  },
}
